jQuery(document).ready(function() {

    // WP-Adminbar: if adminbar exist (should check for visible?) then adjust header

    const wpAdminBar = jQuery('#wpadminbar');

    if ( wpAdminBar.length ) {

        let wpaheight = wpAdminBar.height();
        let final_height = wpaheight + 130;
        jQuery('#wpadminbar').css({top: "0px", position: "fixed", "border-bottom": "1px solid #a0a5aa"});
        jQuery('header').css({top: wpaheight+"px"});
        jQuery('header nav').css("top", final_height+"px");

    } else {

        jQuery('header').css({top: "0px"});
    }
    
});